import { watch } from 'vue'
import { useAuthStore } from '@/features/account/session'
import { useMyProfileStore } from '@/features/account/profile'

/** Retire account display data synchronously; profile failures never end a session. */
export function useAccountSession() {
  const auth = useAuthStore()
  const profile = useMyProfileStore()
  watch(() => auth.userId, id => {
    profile.setAccount(id)
    if (id) void profile.fetchMyProfile().catch(() => {})
  }, { immediate: true, flush: 'sync' })
}
